import type { GeoZoneLocationExclusionRequestApi } from 'types/api/zones/geoZoneLocationExclusion'

// The form holds exactly what the request carries: the zones the user unchecked, per purpose.
export type GeoZoneLocationExclusionFormValues = GeoZoneLocationExclusionRequestApi

export const GEO_ZONE_LOCATION_EXCLUSION_INITIAL_STATE: GeoZoneLocationExclusionFormValues = {
  excludedPricingZoneIds: [],
  excludedServiceZoneIds: [],
}

export const ZONE_FIELD_NAMES = {
  pricing: 'zones.excludedPricingZoneIds',
  service: 'zones.excludedServiceZoneIds',
} as const
